/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_syl_haiku_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is Japanese haiku really about syllables?`)
};

const es_syl_haiku_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿El haiku japonés se basa realmente en sílabas?`)
};

const de_syl_haiku_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geht es beim japanischen Haiku wirklich um Silben?`)
};

const nl_syl_haiku_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Draait de Japanse haiku echt om lettergrepen?`)
};

const fr_syl_haiku_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le haïku japonais repose-t-il vraiment sur des syllabes ?`)
};

const it_syl_haiku_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'haiku giapponese si basa davvero sulle sillabe?`)
};

const pt_br2_syl_haiku_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O haiku japonês é realmente baseado em sílabas?`)
};

const pt_syl_haiku_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O haiku japonês é realmente sobre sílabas?`)
};

const ja_syl_haiku_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日本語の俳句は本当に音節を数えるものなのですか？`)
};

const zh_syl_haiku_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日语俳句真的是按音节计算的吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const syl_haiku_faq4_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.syl_haiku_faq4_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("syl_haiku_faq4_q", locale)
	if (locale === "en") return en_syl_haiku_faq4_q(inputs)
	if (locale === "es") return es_syl_haiku_faq4_q(inputs)
	if (locale === "de") return de_syl_haiku_faq4_q(inputs)
	if (locale === "nl") return nl_syl_haiku_faq4_q(inputs)
	if (locale === "fr") return fr_syl_haiku_faq4_q(inputs)
	if (locale === "it") return it_syl_haiku_faq4_q(inputs)
	if (locale === "pt-BR") return pt_br2_syl_haiku_faq4_q(inputs)
	if (locale === "pt") return pt_syl_haiku_faq4_q(inputs)
	if (locale === "ja") return ja_syl_haiku_faq4_q(inputs)
	return zh_syl_haiku_faq4_q(inputs)
};